import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    maxWidth: 640,
    width: '46.85vw',
    background: themeColor.modalBackground,
  },
  dialogPaperFullWidth: {
    maxWidth: '58.56vw',
  },
  header: {
    backgroundColor: themeColor.white,
    height: '9vh',
    marginBottom: '5vh',
    fontSize: rem(1.125),
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
  },
  headerContent: {},
  icon: {
    borderRadius: '50%',
    width: '1.757vw',
    height: '3.125vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1vw',
  },
  decision: {
    color: theme.palette.secondary.main,
  },
  message: {
    paddingBottom: '1.3020833333333333vh',
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    letterSpacing: 0.43,
    fontSize: rem(2),
    marginBlockStart: '0',
    maxWidth: '100%',
    color: theme.palette.primary.main,
    textAlign: 'center',
    '@media (height: 1080px) and (width: 1920px)': {
      fontSize: rem(2.67),
    },
  },
  subMessage: {
    paddingBottom: '1.3020833333333333vh',
    lineHeight: '1.56',
    color: themeColor.blackish,
    fontSize: rem(1.125),
    marginBlockStart: 0,
    marginBlockEnd: 0,
    fontWeight: 500,
    maxWidth: '100%',
    textAlign: 'center',
    '@media (height: 1080px) and (width: 1920px)': {
      fontSize: rem(1.5),
    },
  },
  messageItem: {
    maxWidth: '100%',
  },
  messageWrapper: {
    height: '8.85vh',
    width: '100%',
    padding: '0 5%',
  },
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  displayBody: {
    flex: '1 1 0',
  },
  spacing: {
    marginLeft: '1.46413vw',
    color: theme.palette.primary.main,
  },

  resultsContainer: {
    display: 'block',
    paddingLeft: '8vw',
    paddingRight: '8vw',
  },
  resultsRowItemContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  resultsItem: {
    height: '6.5vh',
    border: `1px solid ${themeColor.secondaryLight}`,
    backgroundColor: themeColor.white,
    fontSize: rem(0.875),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: rem(1.33),
    letterSpacing: '0.17px',
    color: themeColor.almostblack,
    marginBottom: '1.302083vh',
    paddingLeft: '0.7320644216691069vw',
    paddingRight: '0.7320644216691069vw',
    '@media (aspect-ratio: 16/9)': {
      fontSize: rem(1.125),
    },
  },
  selectListBottomContainer: {
    marginBottom: '2.6041666666666665vh',
    height: '9.24vh',
    paddingLeft: '1.4641288433382138vw',
    paddingRight: '1.4641288433382138vw',
  },
  closeButton: {
    fontSize: rem(1),
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
  },
  comfirmButton: {
    fontSize: rem(1),
  },
  selected: {
    borderRadius: '2px',
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  badge: {
    marginRight: '.735vw',
    width: '1.7569546120058566vw',
    height: '3.125vh',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  eligibilityContainer: {
    height: '45vh',
    paddingTop: '2.6041666666666665vh',
    paddingBottom: '2.6041666666666665vh',
  },
}));
